<div class="wrapper">
  <div *ngIf="amountError" class="row centered error" [translate]="'cardExtension.priceError'">
    Cene su loše unete
  </div>
  <div class="row centered" *ngFor="let amount of paymentTypeAmount; let i = index">
    <div class="tu2" style="margin-top: 2.5px">
      <label
        class="form-control-label"
        [translate]="'paymentType.paymentTypes.' + amount.paymentTypeId"
      ></label>
      <div>
        <mat-form-field style="margin-left: 20px">
          <input
            id="field_price{{ amount.paymentTypeId }}"
            type="number"
            matInput
            class="input-field"
            [disabled]="amount.paymentTypeId === 1"
            name="field_price{{ amount.paymentTypeId }}"
            [(ngModel)]="amount.amount"
            (ngModelChange)="onChangeAmount()"
            (focus)="onTextClick($event)"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="button-wrapper gap-4">
    <button type="button" class="secondary" mat-stroked-button (click)="close()">
      <span [translate]="'cardExtension.close'">Zatvori</span>
    </button>

    <button type="button" class="btn-save" mat-flat-button [disabled]="amountError" (click)="save()">
      <span [translate]="saveLabel">Sacuvaj</span>
    </button>
  </div>
</div>
